import React from 'react';

import { IconColors, SimpleIcon } from './icon-utils';
import type { SimpleIconInterface } from './icon-utils';

export function WarningCircleIcon({
  className,
  fill = IconColors.WarnAmber,
  height = 14,
  width = 14,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height}
      viewBoxDimensions="0 0 16 16"
      width={width}
    >
      <path
        clipRule="evenodd"
        d="M8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333ZM0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8ZM7.33333 3.33333V9.33333H8.66667V3.33333H7.33333ZM7.33333 12V10.6667H8.66667V12H7.33333Z"
        fill={fill}
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
